import axios from "axios";
import { PATH } from "../http/Path";

export const emissionRepository = {
  getEmissionDocuments: async (params: string) => {
    const response = await axios.get(`${PATH.EMISSION_DOCUMENTS}/${params}`);
    return response;
  },
};
